import { useDispatch, useSelector } from "react-redux";
import { useEffect, useMemo } from "react";
import clsx from "clsx";
import Button from "../../components/common/button";
import Shops from "../../components/main/shops";
import { wrapper } from "../../redux";
import { addBreadcrumb } from "../../redux/action-creaters/breadcrumbs";
import styles from "./index.module.scss";
import {
  fetchAboutContent,
  fetchRightNews,
  fetchTeam,
} from "/redux/action-creaters/content";
import Redis from "/lib/redis";
import Breadcrumbs from "../../components/common/breadcrumbs";
import { showPopup } from "../../redux/action-creaters/popup";
import { popupTypes } from "../../redux/reducers/popupReducer";
// eslint-disable-next-line import/no-unresolved
import "swiper/css";
// eslint-disable-next-line import/no-unresolved
import "swiper/css/navigation";
// eslint-disable-next-line import/no-unresolved
import "swiper/css/free-mode";
// eslint-disable-next-line import/no-unresolved
import "swiper/css/thumbs";
// eslint-disable-next-line import/no-unresolved
import "swiper/css/grid";
import { useExternalScript } from "../../hooks/useExternalScript";
import pagesWrapper from "/pagesSrrLogic/pagesWrapper";
import { SITE_PAGE_TYPE } from "/pagesSrrLogic/sitePageType";
import LayoutWrapper from "../../components/layouts/layoutWrapper";
import { checkIsBaltex } from "../../utils";
import { fetchContactsShops } from "../../redux/action-creaters/contacts";
import { sspWrapper } from "../../utils/errors/sspWrapper";
import { getHost } from "../../utils/locationServer";

export default function AboutPage({ scripts, host, isBaltex, isFarkop }) {
  const dispatch = useDispatch();
  const { about } = useSelector((state) => state.content);

  const years = useMemo(() => {
    const result = Object.keys(about)
      .filter((key) => key.includes("history_"))
      .map((key) => +key.replace("history_", ""))
      .filter((val) => !Number.isNaN(val))
      .sort((a, b) => b - a);
    return result;
  }, [about]);

  useEffect(() => {
    if (typeof AOS !== "undefined") {
      // eslint-disable-next-line no-undef
      AOS.init();
    }
  }, []);

  const externalScript = "/aos.js";
  const scriptStatus = useExternalScript(externalScript);

  useEffect(() => {
    if (scriptStatus === "ready") {
      // eslint-disable-next-line no-undef
      AOS.init();
    }
  }, [scriptStatus]);

  return (
    <LayoutWrapper scripts={scripts} host={host}>
      <div
        dangerouslySetInnerHTML={{
          __html: `
                <link href="/aos.css" rel="stylesheet">
            `,
        }}
      />
      <div className={clsx(isBaltex && styles.OverflowBaltex, styles.Overflow)}>
        <div className={styles.Top}>
          <div className="container">
            <Breadcrumbs />
            <div className={styles.TopBlocks}>
              <div>
                <h1>{about.top.NAME}</h1>
                <div
                  className={styles.TopText}
                  dangerouslySetInnerHTML={{ __html: about.top.PREVIEW_TEXT }}
                />
                <div
                  className={styles.TopVideo}
                  onClick={() => {
                    dispatch(showPopup(popupTypes.video, "Bda-0c1Kmok"));
                  }}
                >
                  Смотреть видео
                </div>
              </div>
              <div className={styles.Logo}>
                <img src={about.top.PREVIEW_PICTURE} />
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className={styles.MainInfo}>
            <div
              className={styles.MainInfoBlock}
              data-aos="fade-up"
              dangerouslySetInnerHTML={{ __html: about.block0.PREVIEW_TEXT }}
            ></div>
            <div className={styles.MainInfoBlock}>
              <div data-aos="fade-right">
                <img src={about.block1.PREVIEW_PICTURE} />
              </div>
              <div data-aos="fade-left" className={styles.MainInfoText}>
                <h2>{about.block1.NAME}</h2>
                <div
                  dangerouslySetInnerHTML={{
                    __html: about.block1.PREVIEW_TEXT,
                  }}
                ></div>
              </div>
            </div>
            <div
              className={clsx(styles.MainInfoBlock, styles.MainInfoBlockMain)}
              data-aos="fade-up"
            >
              <div data-aos="fade-right" className={styles.MainInfoText}>
                <h2>{about.block2.NAME}</h2>
                <div
                  dangerouslySetInnerHTML={{
                    __html: about.block2.PREVIEW_TEXT,
                  }}
                ></div>
              </div>
              <div data-aos="fade-left">
                <img src={about.block2.PREVIEW_PICTURE} />
              </div>
            </div>
            {isFarkop && (
              <div
                className={clsx(styles.MainInfoBlock, styles.MainInfoBlockMap)}
              >
                <div data-aos="fade-right" className={styles.MainInfoText}>
                  <h2>{about.future.NAME}</h2>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: about.future.PREVIEW_TEXT,
                    }}
                  ></div>
                </div>
                <img
                  className={styles.Map}
                  data-aos="fade-left"
                  src="/map.svg"
                />
              </div>
            )}
          </div>
        </div>
        {isFarkop && (
          <div className={styles.History} data-aos="fade-up">
            <div className="container">
              <div className={styles.HistoryBlocks}>
                <h2>История компании</h2>

                <div className={styles.HistoryDates}>
                  {years.map((year) => (
                    <div
                      key={year}
                      className={styles.HistoryItem}
                      data-aos="fade-up"
                    >
                      <span className={styles.HistoryYear}>{year}</span>
                      <div
                        className={styles.HistoryText}
                        dangerouslySetInnerHTML={{
                          __html: about[`history_${year}`]?.PREVIEW_TEXT || "-",
                        }}
                      ></div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="container" data-aos="fade-up">
          <div className={styles.Shops}>
            <h2>
              {isFarkop
                ? "Наши магазины и установочные центры"
                : "Наши партнеры"}
            </h2>
            <Shops rows={3} isBaltex={isBaltex} isShopAllShops={true} />
          </div>
        </div>
        {isFarkop && (
          <div className={styles.Bottom}>
            <div className="container">
              <div className={styles.BottomDirector}>
                <div className={styles.BottomPhoto} data-aos="fade-right">
                  <img src={about.director?.PREVIEW_PICTURE} />
                </div>
                <div className={styles.Director} data-aos="fade-left">
                  <div
                    className={styles.DirectorText}
                    dangerouslySetInnerHTML={{
                      __html: about.director?.PREVIEW_TEXT,
                    }}
                  ></div>
                  <div className={styles.DirectorName}>
                    {about.director?.NAME}
                  </div>
                  <div className={styles.DirectorTitle}>
                    Генеральный директор
                  </div>
                  <Button
                    label={"Связаться с директором"}
                    onClick={() => {
                      dispatch(showPopup(popupTypes.feedBack));
                    }}
                  />
                </div>
              </div>
              <br />
              <br />
              <br />
            </div>
          </div>
        )}
      </div>
    </LayoutWrapper>
  );
}

export const getServerSideProps = wrapper.getServerSideProps((store) =>
  sspWrapper(async ({ req, query, resolvedUrl }) => {
    const host = getHost(req);
    const isBaltex = checkIsBaltex(host);
    await store.dispatch(
      await fetchAboutContent(Redis, Boolean(query.reset), isBaltex),
    );
    await store.dispatch(await fetchTeam(Redis, Boolean(query.reset)));
    await store.dispatch(await fetchRightNews(Redis, Boolean(query.reset)));
    store.dispatch(addBreadcrumb({ link: "/about/", name: "О компании" }));

    await store.dispatch(fetchContactsShops(Redis, Boolean(query.reset)));

    return pagesWrapper(
      { pageType: SITE_PAGE_TYPE.static },
      store,
      Redis,
      {
        query,
        req,
        resolvedUrl,
      },
      "/about/",
    );
  }, "/about/"),
);
